import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getTrustees, saveBatchTrustees } from '../../api/trustees';
import type { Trustee } from '../../types/Trustee';
import { t } from '../../i18n/t';

const columnDefs: ColDef<Trustee>[] = [
  {
    field: 'trusteeId',
    headerName: t('trustees.columns.trusteeId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<Trustee>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'trusteeName', headerName: t('trustees.columns.trusteeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<Trustee> => ({ trusteeId: 0, trusteeName: '' });

export function TrusteesPage() {
  return (
    <LopCrudPage<Trustee>
      resourceCode="trustees"
      titleKey="trustees.pageTitle"
      idField="trusteeId"
      getRows={getTrustees}
      saveBatch={(added, modified, deletedIds) => saveBatchTrustees(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
